import * as Yup from "yup";
import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { stringValidation } from "../providers/validations";
import Field from "../components/Field";
import { FileUpload, Select, Text } from "../inputs";
import { Form } from "../template";
import { SHA256 } from "crypto-js";
import { Permission } from "./List";

const UserForm = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const props = {
    editable: true,
    isDeletable: true,
    model: "user",
    text: id ? "Хэрэглэгчийн мэдээлэл" : "Хэрэглэгч бүртгэх",
    id: id,
    init: {},
    validationSchema: Yup.object().shape({
      lastname: stringValidation(true),
      firstname: stringValidation(true),
      phone: stringValidation(true),
      role: stringValidation(true),
      email: stringValidation(true),
      password: stringValidation(true),
    }),
  };
  const beforeSubmit = async (data) => {
    let temp = data;
    if (!id) temp.password = SHA256(data?.password).toString();

    return temp;
  };
  return (
    <Form {...props} beforeSubmit={beforeSubmit}>
      {({ submited, disabled, values }) => {
        return (
          <div className="p-5 bg-white  grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="flex flex-col gap-4">
              <Field
                name="lastname"
                label={t("user.lastname")}
                disabled={disabled}
                component={Text}
                type="text"
                className={`text-black `}
              />
              <Field
                name="firstname"
                label={t("user.firstname")}
                disabled={disabled}
                component={Text}
                type="text"
                className={`text-black `}
              />
              <Field
                name="phone"
                label={t("user.phone")}
                disabled={disabled}
                component={Text}
                type="text"
                className={`text-black `}
              />
            </div>
            <div className="flex flex-col gap-4">
              <Field
                name="email"
                label={t("user.email")}
                disabled={disabled}
                component={Text}
                type="text"
                className={`text-black `}
              />
              <Field
                name="role"
                label={t("user.role")}
                disabled={disabled}
                component={Select}
                items={Permission}
                type="text"
              />
              <Field
                name="password"
                label={t("user.password")}
                disabled={disabled}
                component={Text}
                type="text"
                className={`text-black `}
              />
            </div>
          </div>
        );
      }}
    </Form>
  );
};

export default UserForm;
